export type JSONPrimitive = string | number | boolean | null | undefined;

export type JSON = JSONPrimitive | { [key: string | number]: JSON } | JSON[];

export type Serializable<T> = {
    [P in keyof T]: T[P] extends JSON
        ? T[P]
        : T[P] extends Function | Date | Map<any, any> | Set<any> | symbol
          ? never
          : T[P] extends (infer U)[]
            ? Serializable<U>[]
            : Serializable<T[P]>;
};

export interface Metadata {
    name: string;
    version?: string;
    bundledWith?: Record<string, string | undefined>;
    sharedDependencies: Record<string, string>;
    dependencies?: Record<string, string>;
    entrypoints?: Record<string, { css: string[]; js: string[]; module?: true }>;
}
